import { render } from "./AppSidebar.vue?vue&type=template&id=1a5b8f37&ts=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__